import {format} from "@constants";
import {Stack, Typography, TypographyProps} from "@mui/material";
import {translate} from "@util";
import dayjs from "dayjs";
import {Event} from "react-big-calendar";

const Time = ({
  event,
  day,
  minimize = false,
}: {
  event: Event;
  day: Date;
  minimize?: boolean;
}) => {
  const start = dayjs(event.start);
  const end = dayjs(event.end);
  const startDay = dayjs(day).startOf("day");
  const endDay = dayjs(day).endOf("day");

  const isAllDay =
    (start.isBefore(startDay) || start.isSame(startDay)) &&
    (end.isAfter(endDay) || end.isSame(endDay));

  const startsAtMidnight = start.isSame(startDay) || start.isBefore(startDay);
  const endsAtMidnight = end.isSame(endDay) || end.isAfter(endDay);

  const render = () => {
    const typoProps: TypographyProps = {
      variant: "body2",
      color: "textSecondary",
      lineHeight: 1,
    };
    if (isAllDay)
      return (
        <Typography {...typoProps}>{translate("calendar.allDay")}</Typography>
      );
    if (!startsAtMidnight && endsAtMidnight)
      return (
        <Typography {...typoProps}>
          {start.format(format.time.short)}
        </Typography>
      );
    if (startsAtMidnight && !endsAtMidnight)
      return (
        <Typography {...typoProps}>
          {translate("calendar.until")} {end.format(format.time.short)}
        </Typography>
      );
    return (
      <Typography
        {...typoProps}>{`${start.format(format.time.short)} - ${end.format(format.time.short)}`}</Typography>
    );
  };

  return (
    <Stack
      className="agenda-row-time"
      direction={minimize ? "row" : "column"}
      alignItems={"start"}
      justifyContent={minimize ? "start" : "center"}
      width={150}
      py={minimize ? 0 : 0.5}>
      {render()}
    </Stack>
  );
};

export {Time};
